import { type AxiosResponse } from 'axios'

import axiosInstance from 'api/axiosInstance'
import { type ProfileGroupsResponse } from 'types/api/social'

export const getProfileGroups = async () => {
    const { data } = await axiosInstance<AxiosResponse<ProfileGroupsResponse>>({
        method: 'GET',
        url: '/api/user/extended-group'
    })
    return data?.data
}
